/** Brand color presets — user picks one; mode (light/dark) is separate. */
export const COLOR_PRESETS = [
  {
    id: 'revive',
    label: 'Revive Blue',
    primary: '#154A8A',
    secondary: '#3949ab',
    accent: '#FF8C42',
    gradient: 'linear-gradient(90deg, #154A8A 0%, #3949ab 50%, #5c6bc0 100%)',
  },
  {
    id: 'ocean',
    label: 'Ocean',
    primary: '#0077B6',
    secondary: '#00B4D8',
    accent: '#FF6B35',
    gradient: 'linear-gradient(90deg, #0077B6 0%, #0096C7 50%, #00B4D8 100%)',
  },
  {
    id: 'emerald',
    label: 'Emerald',
    primary: '#059669',
    secondary: '#10B981',
    accent: '#F59E0B',
    gradient: 'linear-gradient(90deg, #047857 0%, #059669 50%, #10B981 100%)',
  },
  {
    id: 'violet',
    label: 'Violet',
    primary: '#6D28D9',
    secondary: '#8B5CF6',
    accent: '#EC4899',
    gradient: 'linear-gradient(90deg, #5B21B6 0%, #7C3AED 50%, #8B5CF6 100%)',
  },
  {
    id: 'rose',
    label: 'Rose',
    primary: '#BE123C',
    secondary: '#E11D48',
    accent: '#F97316',
    gradient: 'linear-gradient(90deg, #9F1239 0%, #BE123C 50%, #E11D48 100%)',
  },
  {
    id: 'slate',
    label: 'Slate',
    primary: '#334155',
    secondary: '#475569',
    accent: '#0EA5E9',
    gradient: 'linear-gradient(90deg, #1E293B 0%, #334155 50%, #475569 100%)',
  },
];

export const BORDER_RADIUS_OPTIONS = [
  { id: 'soft', label: 'Soft', value: 16 },
  { id: 'medium', label: 'Medium', value: 10 },
  { id: 'sharp', label: 'Sharp', value: 6 },
];

export const getPresetById = (paletteId) =>
  COLOR_PRESETS.find((p) => p.id === paletteId) ?? COLOR_PRESETS[0];

export const getBorderRadiusValue = (borderRadiusId) =>
  BORDER_RADIUS_OPTIONS.find((o) => o.id === borderRadiusId)?.value ?? 10;
